/* eslint-disable @typescript-eslint/restrict-template-expressions */
import {
  LeaveManagementStatus,
  LeaveStatus,
  RoleStatus,
  Strings,
  AssetStatus,
  EmployeeStatus,
  CandidateStatus,
  ClientStatus,
  ProjectStatus,
  PriorityStatus,
  ReviewStatus,
  IntervieweeStatus,
  RepairingStatus,
  InternStatus,
} from '@app/constants';
import { Label } from '../label';

interface Props {
  status: string;
  suffix?: string;
}

const StatusTag = ({ status, suffix = '' }: Props) => {
  return (
    <Label color={(colorMapping as any)[status] ?? 'default'}>{`${
      (statusLabelMapping as any)[status] ?? status
    } ${suffix}`}</Label>
  );
};

export const colorMapping = {
  [LeaveStatus[LeaveStatus.Approved]]: 'success',
  [LeaveStatus[LeaveStatus.Declined]]: 'error',
  [LeaveStatus[LeaveStatus.Pending]]: 'warning',
  [LeaveStatus[LeaveStatus.Draft]]: 'default',
  [LeaveManagementStatus[LeaveManagementStatus.Active]]: 'success',
  [LeaveManagementStatus[LeaveManagementStatus.Inactive]]: 'error',
  [EmployeeStatus[EmployeeStatus.Active]]: 'success',
  [EmployeeStatus[EmployeeStatus.Inactive]]: 'error',
  [RoleStatus[RoleStatus.Inactive]]: 'error',
  [AssetStatus[AssetStatus.Assigned]]: 'default',
  [AssetStatus[AssetStatus.Available]]: 'success',
  [AssetStatus[AssetStatus.Repaired]]: 'success',
  [AssetStatus[AssetStatus.Repairing]]: 'warning',
  [AssetStatus[AssetStatus.Damaged]]: 'error',
  [CandidateStatus[CandidateStatus.Saved]]: 'default',
  [CandidateStatus[CandidateStatus.Selected]]: 'success',
  [CandidateStatus[CandidateStatus.InProgress]]: 'quaternary',
  [CandidateStatus[CandidateStatus.Rejected]]: 'error',
  [CandidateStatus[CandidateStatus.InterviewCancelled]]: 'warning',
  [CandidateStatus[CandidateStatus.Intern]]: 'info',
  [CandidateStatus[CandidateStatus.Employee]]: 'success',
  [CandidateStatus[CandidateStatus.InterviewScheduled]]: 'tertiary',
  [ClientStatus[ClientStatus.Active]]: 'success',
  [ClientStatus[ClientStatus.Inactive]]: 'error',
  [ProjectStatus[ProjectStatus.Delivered]]: 'success',
  [ProjectStatus[ProjectStatus.Hold]]: 'error',
  [PriorityStatus[PriorityStatus.High]]: 'success',
  [PriorityStatus[PriorityStatus.Medium]]: 'tertiary',
  [PriorityStatus[PriorityStatus.Low]]: 'error',
  [ReviewStatus[ReviewStatus.Good]]: 'tertiary',
  [ReviewStatus[ReviewStatus.Poor]]: 'error',
  [ReviewStatus[ReviewStatus.Average]]: 'warning',
  [ReviewStatus[ReviewStatus.VeryGood]]: 'info',
  [ReviewStatus[ReviewStatus.Excellent]]: 'success',

  [IntervieweeStatus[IntervieweeStatus.DecisionPending]]: 'warning',
  [RepairingStatus[RepairingStatus.Assigned]]: 'default',
  [RepairingStatus[RepairingStatus.Repaired]]: 'success',
  [RepairingStatus[RepairingStatus.Repairing]]: 'tertiary',
  [InternStatus[InternStatus.PromotedAsEmployee]]: 'warning',
  [InternStatus[InternStatus.Candidate]]: 'tertiary',
  [InternStatus[InternStatus.SelectedAsEmployee]]: 'success',
  [InternStatus[InternStatus.SelectedAsIntern]]: 'info',
  [InternStatus[InternStatus.InternFinalWeek]]: 'quaternary',
};

export const statusLabelMapping = {
  [LeaveStatus[LeaveStatus.Approved]]: Strings.status.approved,
  [LeaveStatus[LeaveStatus.Declined]]: Strings.status.declined,
  [LeaveStatus[LeaveStatus.Pending]]: Strings.status.pending,
  [LeaveStatus[LeaveStatus.Draft]]: Strings.status.draft,
  [LeaveManagementStatus[LeaveManagementStatus.Active]]: Strings.status.active,
  [LeaveManagementStatus[LeaveManagementStatus.Inactive]]: Strings.status.inactive,
  [EmployeeStatus[EmployeeStatus.Active]]: Strings.status.active,
  [EmployeeStatus[EmployeeStatus.Inactive]]: Strings.status.inactive,
  [RoleStatus[RoleStatus.Active]]: Strings.status.active,
  [RoleStatus[RoleStatus.Inactive]]: Strings.status.inactive,
  [CandidateStatus[CandidateStatus.Saved]]: Strings.status.saved,
  [CandidateStatus[CandidateStatus.Selected]]: Strings.status.Selected,
  [CandidateStatus[CandidateStatus.InProgress]]: Strings.status.inProgress,
  [CandidateStatus[CandidateStatus.Rejected]]: Strings.status.rejected,
  [CandidateStatus[CandidateStatus.InterviewCancelled]]: Strings.status.InterviewCancelled,
  [CandidateStatus[CandidateStatus.Intern]]: Strings.status.intern,
  [CandidateStatus[CandidateStatus.Employee]]: Strings.status.employee,
  [CandidateStatus[CandidateStatus.InterviewScheduled]]: Strings.status.InterviewScheduled,
  [ClientStatus[ClientStatus.Active]]: Strings.status.active,
  [ClientStatus[ClientStatus.Inactive]]: Strings.status.inactive,
  [ProjectStatus[ProjectStatus.Delivered]]: Strings.status.delivered,
  [ProjectStatus[ProjectStatus.Hold]]: Strings.status.hold,
  [PriorityStatus[PriorityStatus.High]]: Strings.status.high,
  [PriorityStatus[PriorityStatus.Medium]]: Strings.status.medium,
  [PriorityStatus[PriorityStatus.Low]]: Strings.status.low,
  [ReviewStatus[ReviewStatus.Good]]: Strings.status.good,
  [ReviewStatus[ReviewStatus.Poor]]: Strings.status.poor,
  [ReviewStatus[ReviewStatus.Average]]: Strings.status.average,
  [RepairingStatus[RepairingStatus.Assigned]]: Strings.status.assigned,
  [RepairingStatus[RepairingStatus.Repaired]]: Strings.status.repaired,
  [RepairingStatus[RepairingStatus.Repairing]]: Strings.status.repairing,
  [IntervieweeStatus[IntervieweeStatus.DecisionPending]]: Strings.status.decisionPending,
  [InternStatus[InternStatus.PromotedAsEmployee]]: Strings.status.promotedAsEmployee,
  [InternStatus[InternStatus.Candidate]]: Strings.status.candidate,
  [InternStatus[InternStatus.SelectedAsEmployee]]: Strings.status.selectedAsEmployee,
  [InternStatus[InternStatus.SelectedAsIntern]]: Strings.status.selectedAsIntern,
  [InternStatus[InternStatus.InternFinalWeek]]: Strings.status.internFinalWeek,
};

export default StatusTag;
